import { getAdminHomePath } from "./adminRoles"

/** Auth/onboarding paths — authenticated users must not land here (incl. browser back). */
export const AUTH_GUEST_PATHS = [
  "/login",
  "/verify-otp",
  "/forgot-password",
  "/reset-password",
  "/request-invite",
  "/create-account",
  "/onboarding",
]

export const isMemberUser = user =>
  String(user?.type || "").toLowerCase() === "member"

/** True when Redux holds a non-empty auth token (null and "" are logged out). */
export const hasAuthSession = token =>
  token != null && String(token).trim() !== ""

export const isAuthGuestPath = pathname => {
  const path = String(pathname || "")
  return AUTH_GUEST_PATHS.some(
    guest => path === guest || path.startsWith(`${guest}/`),
  )
}

export const isOnboardingPath = pathname => {
  const path = String(pathname || "")
  return path === "/onboarding" || path.startsWith("/onboarding/")
}

export const isAdminAppPath = pathname =>
  String(pathname || "").startsWith("/admin")

export const isMemberAppPath = pathname => {
  const path = String(pathname || "")
  if (!path || path === "/") return true
  if (isAdminAppPath(path)) return false
  if (path.startsWith("/city-portal")) return false
  if (path.startsWith("/public/")) return false
  if (isAuthGuestPath(path)) return false
  if (path === "/logout") return false
  return true
}

/** Member → /dashboard; super_admin, admin, city_admin, etc. → /admin/dashboard */
export const getAuthenticatedHomePath = user => {
  if (!user) return "/login"
  return isMemberUser(user) ? "/dashboard" : getAdminHomePath()
}

const resolveUserType = userOrType =>
  typeof userOrType === "string" ? userOrType : userOrType?.type

const normalizePath = path =>
  String(path || "")
    .replace(/^\/+/, "")
    .replace(/\/+$/, "")

/** Member sees the bare path; admins get it under /admin. */
export const getRoleScopedPath = (userOrType, path) => {
  const isMember =
    String(resolveUserType(userOrType) || "").toLowerCase() === "member"
  const cleanPath = normalizePath(path)
  if (!cleanPath) return isMember ? "/" : "/admin"
  return isMember ? `/${cleanPath}` : `/admin/${cleanPath}`
}
